import LoginPage from "../../section/auth/LoginPage";

export default function Login(){
    return(
        <LoginPage />
    )
}